import { POST_FOUNDERS_ERROR, POST_FOUNDERS_START, POST_FOUNDERS_SUCCESS } from '../../types';

export default function post_founders(state, action) {
  switch (action.type) {
    case POST_FOUNDERS_START:
      return { ...state };
    case POST_FOUNDERS_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case POST_FOUNDERS_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}